import { useQueryApi } from "api/hooks.ts";
import { countryApi } from "api/TenantSlug/Country/api.ts";

import GetCountriesResponse = App.Http.Responses.Country.GetCountriesResponse;
import GetCountryResponse = App.Http.Responses.Country.GetCountryResponse;

// Hook to get list of countries
export const useGetCountriesQuery = (options = {}) => {
    return useQueryApi<GetCountriesResponse>({
        queryKey: ["getCountries"],
        queryFn: () => countryApi.index(),
        ...options,
    });
};

// Hook to get a specific country
export const useGetCountryQuery = (countryId: string, options = {}) => {
    return useQueryApi<GetCountryResponse>({
        queryKey: ["getCountry", countryId],
        queryFn: () => countryApi.show(countryId),
        ...options,
    });
};
